import { AR_LETTERS, HE_LETTERS, PUNCATUATIONS } from "./subtitle";

export class SubtitleSegment {
  private rtlChars =
    /[\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  constructor(
    public Text: string,
    public StartTimeMS: number,
    public EndTimeMS: number,
    public Commands?: string,
  ) {}
  public get Duration() {
    return this.EndTimeMS - this.StartTimeMS;
  }
  public get isTextRTL() {
    return this.rtlChars.test(this.Text);
  }
}
